import TermEditor from "../glossaryeditor/GlossaryTermEditor";


const Example = ()=>{
    return <TermEditor/>
}

export default Example;
